import type { ReactNode } from 'react'
import { Body1, makeStyles, tokens } from '@fluentui/react-components'
import { WarningRegular } from '@fluentui/react-icons'

// THE YELLOW WARNING BOX. It was the Assignments screen's own (Company Roles:
// "N companies have no approvers."), inline there, and moved here on
// 2026-09-30 (owner, D-241) when References → Vendors needed the same box for
// its errant ZIP codes. One urgent fact, said once at the top of a list rather
// than repeated on every row it concerns.
const useStyles = makeStyles({
  banner: {
    display: 'flex',
    // Icon, sentence and button share one centre line, so a one-line
    // sentence sits level with the taller button (owner, 2026-09-30).
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    marginBottom: '16px',
    borderRadius: tokens.borderRadiusMedium,
    border: `1px solid ${tokens.colorPaletteYellowBorder1}`,
    borderLeftWidth: '3px',
    backgroundColor: tokens.colorPaletteYellowBackground1,
    color: tokens.colorPaletteYellowForeground2,
  },
  icon: { flexShrink: 0 },
  text: { flexGrow: 1 },
  action: { flexShrink: 0 },
})

export function WarningBanner({ children, action }: { children: ReactNode; action?: ReactNode }) {
  const s = useStyles()
  return (
    <div className={s.banner}>
      <WarningRegular className={s.icon} aria-hidden="true" />
      <Body1 className={s.text}>{children}</Body1>
      {action !== undefined && <div className={s.action}>{action}</div>}
    </div>
  )
}
